require("./csn_cookies.js");
require("./csn_browserpush.js");
require("./csn_social.js");

$(function () {
    if (window.BrowserPush) {
        window.BrowserPush.initConnection($(".site-nav-wrapper").data("tenant"));
    }
});